import Vue from "vue";
import VueRouter from "vue-router";

// Importar módulos
import PublicRoutes from "@/router/modules/public";
import ProtectedRoutes from "@/router/modules/protected/shared";

// Importar servicios
import AuthServices from "@/services/AuthServices";

// Importar items
import Items from "@/utils/items.js";

Vue.use(VueRouter);

const routes = [].concat(ProtectedRoutes).concat(PublicRoutes);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// Verificación antes de pasar a la siguiente pantalla
router.beforeEach(async (to, from, next) => {
  // Verificar si la ruta a la que se va requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verificar si el usuario inició sesión
    if (localStorage.getItem("auth-token")) {
      // Leer el token
      const payload = atob(localStorage.getItem("auth-token").split(".")[1]);

      // Mandar al usuario a la siguiente página
      if (payload.includes("employee")) {
        // Obtener perfil del usuario
        const profile = await AuthServices.getProfile();

        // Obtener rutas disponibles
        const availableRoutes = Items.authenticated
          .filter(item => profile.tabs.includes(item.key))
          .map(item => item.rootRoute);

        // Obtener primera pestaña
        const { key: firstTab } =
          profile.tabs && profile.tabs?.length > 0
            ? Items.authenticated.find(item => profile.tabs.includes(item.key))
            : { key: "settings" };

        // Obtener el inicio de la ruta
        const toPath = `/${to.path.split("/")[1]}`;

        // Verificar si el inicio de la ruta to.path coincide con alguna de las rutas disponibles
        if (availableRoutes.includes(toPath) || to.name === "settings") {
          next();
        } else {
          next({ name: firstTab });
        }
      } else {
        next();
      }
    } else {
      // Mandar al usuario a iniciar seisón
      next({ name: "sign-in", params: { nextUrl: to.fullPath } });
    }
  }
  // Verificar si es una ruta especial
  else if (to.matched.some(record => record.meta.anyUser)) {
    // Mandar al usuario a la siguiente página
    next();
  }
  // Verificar si es una ruta pública
  else if (to.matched.some(record => record.meta.guest)) {
    // Verificar si el usuario inició sesión
    if (!localStorage.getItem("auth-token")) {
      // Mandar al usuario a la siguiente página
      next();
    } else {
      // Leer el token
      const payload = atob(localStorage.getItem("auth-token").split(".")[1]);

      // Mandar al usuario al dashboard
      if (payload.includes("employee")) {
        // Obtener perfil del usuario
        const profile = await AuthServices.getProfile();

        // Obtener primera pestaña
        const { key: firstTab } =
          profile.tabs && profile.tabs?.length > 0
            ? Items.authenticated.find(item => profile.tabs.includes(item.key))
            : { key: "settings" };

        // Ir a la primera pestaña
        next({ name: firstTab });
      } else {
        next({ name: "dashboard" });
      }
    }
  } else {
    next({ name: "sign-in" });
  }
});

export default router;
